import React from "react";
import Dispatcher from "../../dispatcher";

export default function withChrome(Component) {
  return class ComponentWithChrome extends React.Component {
    state = {
      chromeId: null
    };

    componentDidMount() {
      Dispatcher.bind(Dispatcher.CHANGE_CHROME, this.chromeChanged);
    }

    componentWillUnmount() {
      Dispatcher.unbind(Dispatcher.CHANGE_CHROME, this.chromeChanged);
    }

    chromeChanged = name => {
      this.setState({
        chromeId: name
      });
    };

    render() {
      return <Component {...this.props} chromeId={this.state.chromeId} />;
    }
  };
}
